module.exports = __webpack_public_path__ + "static/payments-accepted.683146c9.png";